import { Apis } from "../../lib/Apis";

const getApiError = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export const usePricing = () => {
  const getPricing = async (setPricingList) => {
    try {
      const response = await Apis.getPricing();
      const payload = response?.data?.data;
      const list = payload?.pricing || (Array.isArray(payload) ? payload : []);
      setPricingList(list);
      return list;
    } catch (error) {
      console.error("Failed to fetch pricing list:", error);
      setPricingList([]);
      throw new Error(getApiError(error, "Failed to fetch pricing list."));
    }
  };

  const addPricing = async (data) => {
    try {
      const response = await Apis.createPricing(data);
      const body = response?.data;
      if (body?.success === false) {
        throw new Error(body?.message || "Failed to add pricing data.");
      }
      return body;
    } catch (error) {
      throw new Error(getApiError(error, "Failed to add pricing data."));
    }
  };

  const updatePricing = async (id, data) => {
    try {
      const response = await Apis.updatePricing(id, data);
      const body = response?.data;
      if (body?.success === false) {
        throw new Error(body?.message || "Failed to update pricing data.");
      }
      return body;
    } catch (error) {
      throw new Error(getApiError(error, "Failed to update pricing data."));
    }
  };

  const deletePricing = async (id) => {
    try {
      const response = await Apis.deletePricing(id);
      const body = response?.data;
      if (body?.success === false) {
        throw new Error(body?.message || "Failed to delete pricing data.");
      }
      return body;
    } catch (error) {
      throw new Error(getApiError(error, "Failed to delete pricing data."));
    }
  };

  return {
    getPricing,
    addPricing,
    updatePricing,
    deletePricing,
  };
};

export const usePremiumPricing = () => {
  const getPremiumPricing = async (setList) => {
    try {
      const response = await Apis.getPremiumPricing();
      const payload = response?.data?.data;
      const list = payload?.pricing || (Array.isArray(payload) ? payload : []);
      setList(list);
      return list;
    } catch (error) {
      console.error("Failed to fetch premium pricing list:", error);
      setList([]);
      throw new Error(getApiError(error, "Failed to fetch premium pricing list."));
    }
  };

  const addPremiumPricing = async (data) => {
    try {
      const response = await Apis.createPremiumPricing(data);
      const body = response?.data;
      if (body?.success === false) {
        throw new Error(body?.message || "Failed to add premium pricing data.");
      }
      return body;
    } catch (error) {
      throw new Error(getApiError(error, "Failed to add premium pricing data."));
    }
  };

  const updatePremiumPricing = async (id, data) => {
    try {
      const response = await Apis.updatePremiumPricing(id, data);
      const body = response?.data;
      if (body?.success === false) {
        throw new Error(body?.message || "Failed to update premium pricing data.");
      }
      return body;
    } catch (error) {
      throw new Error(getApiError(error, "Failed to update premium pricing data."));
    }
  };

  const deletePremiumPricing = async (id) => {
    try {
      const response = await Apis.deletePremiumPricing(id);
      const body = response?.data;
      if (body?.success === false) {
        throw new Error(body?.message || "Failed to delete premium pricing data.");
      }
      return body;
    } catch (error) {
      throw new Error(getApiError(error, "Failed to delete premium pricing data."));
    }
  };

  return {
    getPremiumPricing,
    addPremiumPricing,
    updatePremiumPricing,
    deletePremiumPricing,
  };
};
